<template>
    <ConfirmationModal
        title="Please confirm your action!"
        yes="Override filter"
        no="Cancel"
        @input="onAction"
    >
        This action will override the current filters and replace with the quick filter selection
    </ConfirmationModal>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from '@evidentid/vue-property-decorator';

    import ConfirmationModal from '@/components/confirmation-modal/ConfirmationModal.vue';

    // PRODUCT-26110 QA fixes4: declares every event this procedure component `$emit`s --
    // without a declared `emits`, Vue 3 warns "Component emitted event 'abort'/'finish'
    // but it is neither declared in the emits option nor as an 'onAbort'/'onFinish' prop"
    // every time it fires.
    @Component({
        components: { ConfirmationModal },
        emits: [ 'abort', 'finish' ],
    })

    export default class ConfirmFilterOverrideProcedure extends Vue {
        // PRODUCT-26110 QA fixes4: `uuid` is unused; declared purely so Vue 3 doesn't warn
        // "Extraneous non-props attributes (uuid)" (see UploadEntityDocumentProcedure.vue).
        @Prop({ type: String, default: '' })
        private uuid?: string;

        private onAction(confirmed: boolean): void {
            confirmed ? this.$emit('finish') : this.$emit('abort');
        }
    }
</script>
